import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
// BACKEND_URL is the host root — used for static asset paths that ALREADY include "/api/..."
export const ASSET_BASE = BACKEND_URL;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Resolve image url: if already absolute (http/https) keep as-is; else prepend host root.
// IMPORTANT: do NOT prepend `${API}` because uploaded image URLs already start with "/api/uploads/".
export const resolveImg = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${ASSET_BASE}${u}`;
};

export const WHATSAPP_NUMBER = "573017668909";
export const WHATSAPP_DISPLAY = "+57 301 766 8909";
export const buildWhatsAppLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text || "Hola Emmanuel, vi tu portafolio.")}`;
